<div fxLayout="column" fxLayoutGap="1rem" >
  <h2 id="title" class="page-header" fxFill>Consulta e impresión de Remitos</h2>
  <form fxLayout="column" fxLayoutAlign="start" [formGroup]="searchCriteria" #formDirective="ngForm"
        autocomplete="off">
    <div fxLayout="row" style="text-align:right;" fxLayoutGap=".75rem">
      <!-- ***** FILE UPLOAD COMPONENT ***** -->
      <rem-file-upload fxFlex="100%"
                       endpoint="dispatch"
                       [showSuccessResponseNotifications]="false"
                       (fileUploadSuccessEvent)="handleFileUploadSuccess($event)"
      ></rem-file-upload>

      <!-- ***** SEARCH BUTTON ***** -->
      <button mat-icon-button type="submit" class="view-remito-buttons"
              (click)="searchAndPrint(false)">
        <mat-icon>pageview</mat-icon>
      </button>


      <!-- ***** Search And Download Excel file button ***** -->
      <button mat-icon-button class="view-remito-buttons"
              (click)="searchAndPrint(true)" [disabled]="isDownloadingExcel">
        <mat-icon *ngIf="!isDownloadingExcel">description</mat-icon>
        <mat-spinner *ngIf="isDownloadingExcel" class="loading-spinner-small" diameter="15"></mat-spinner>
      </button>



    </div>
    <mat-divider class="mat-divider-header"></mat-divider>
    <div fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap=".75rem">

      <!-- ***** VIN ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 48.5%" fxFlex.lt-sm="1 1 47.5%" appearance="outline">
        <mat-label>VIN Letras</mat-label>
        <input matInput #vinLetrasInput [formControl]="vinLetrasControl" placeholder="Vin Letras" maxlength="11">
        <mat-hint align="end">{{vinLetrasInput.value.length || 0}}/11</mat-hint>
      </mat-form-field>
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 48.5%" fxFlex.lt-sm="1 1 47.5%" appearance="outline">
        <mat-label>VIN Numeros</mat-label>
        <input matInput #vinNumerosInput [formControl]="vinNumerosControl" placeholder="Vin Numeros" minlength="6" maxlength="6">
        <mat-hint align="end">{{vinNumerosInput.value.length || 0}}/6</mat-hint>
      </mat-form-field>

      <!-- ***** PTO EMISION ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 49%" fxFlex.lt-sm="1 1 100%" appearance="outline">
        <mat-label>Pto Emision</mat-label>
        <mat-select placeholder="Pto Emision" [formControl]="ptoEmisionControl" panelClass="mat-select-dropdown">
          <mat-option [value]="" (click)="ptoEmisionControl.setValue('')">--</mat-option>
          <mat-option *ngFor="let ptoEmision of filteredPtoEmision"
                      [value]="ptoEmision.id" ngDefaultControl >
            {{ ptoEmision.id }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- ***** NRO ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 23.5%" fxFlex.lt-sm="1 1 47.5%" appearance="outline">
        <mat-label>Número de Remito inicial</mat-label>
        <input matInput placeholder="NRO Remito" [formControl]="nroMinControl">
      </mat-form-field>
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 23.5%" fxFlex.lt-sm="1 1 47.5%" appearance="outline">
        <mat-label>Número de Remito final </mat-label>
        <input matInput placeholder="NRO Remito" [formControl]="nroMaxControl" (input)="this.onNroMaxEntry()">
      </mat-form-field>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="start"  fxLayoutGap=".75rem">

      <!-- ***** DESTINATARIO ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 100%" fxFlex.lt-sm="1 1 100%" appearance="standard">
        <mat-label>Destinatario</mat-label>
        <input type="text" matInput [formControl]="destinatarioControl" [matAutocomplete]="autoDestinatario">
        <mat-autocomplete #autoDestinatario="matAutocomplete">
          <mat-option [value]="" (click)="destinatarioControl.setValue('')">--</mat-option>
          <mat-option *ngFor="let destinatario of filteredDestinatario | async"
                      [value]="destinatario.id + ' - ' + destinatario.desc + ' - ' + destinatario.dlCiudad">
            {{destinatario.id}} - {{destinatario.desc}} - {{destinatario.dlCiudad}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="destinatarioControl.hasError('in-valid-list')">Seleccione un Destinatario Válido</mat-error>
      </mat-form-field>

      <!-- ***** TRANSPORTE ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 48.5%" fxFlex.lt-sm="1 1 100%" appearance="standard">
        <mat-label>Transporte</mat-label>
        <input type="text" matInput [formControl]="transporteControl" [matAutocomplete]="autoTransporte">
        <mat-autocomplete #autoTransporte="matAutocomplete">
          <mat-option [value]="" (click)="transporteControl.setValue('')">--</mat-option>
          <mat-option *ngFor="let transporte of filteredTransporte | async"
                      [value]="transporte.id + ' - ' + transporte.desc">
            {{transporte.id}} - {{transporte.desc}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="transporteControl.hasError('in-valid-list')">Seleccione un Transportista Válido</mat-error>
      </mat-form-field>

      <!-- ***** ORIGEN ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 48.5%" fxFlex.lt-sm="1 1 100%" appearance="standard">
        <mat-label>Origen</mat-label>
        <input type="text" matInput [formControl]="origenControl" [matAutocomplete]="autoOrigen">
        <mat-autocomplete #autoOrigen="matAutocomplete">
          <mat-option [value]="" (click)="origenControl.setValue('')">--</mat-option>
          <mat-option *ngFor="let origen of filteredOrigen | async"
                      [value]="origen.id + ' - ' + origen.desc + ' - ' + origen.dlCiudad">
            {{origen.id}} - {{origen.desc}} - {{origen.dlCiudad}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="origenControl.hasError('in-valid-list')">Seleccione un Origen Válido</mat-error>
      </mat-form-field>

      <!-- ***** Despacho Desde ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 48.5%" fxFlex.lt-sm="1 1 100%" appearance="outline">
        <mat-label>Despacho Desde</mat-label>
        <input matInput [matDatepicker]="despachoDesde" [formControl]="despachoDesdeControl"
               (dateChange)="setDespachoDesde(despachoDesdeControl.value)">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="despachoDesde"></mat-datepicker-toggle>
        <mat-datepicker #despachoDesde></mat-datepicker>
      </mat-form-field>

      <!-- ***** Despacho Hasta ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 48.5%" fxFlex.lt-sm="1 1 100%" appearance="outline">
        <mat-label>Despacho Hasta</mat-label>
        <input matInput [matDatepicker]="despachoHasta" [formControl]="despachoHastaControl"
               (dateChange)="setDespachoHasta(despachoHastaControl.value)" [min]="despachoDesdeControl.value">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="despachoHasta"></mat-datepicker-toggle>
        <mat-datepicker #despachoHasta></mat-datepicker>
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start"  fxLayoutGap=".75rem">
      <!-- ***** ESTADO ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 48.5%" fxFlex.lt-sm="1 1 100%" appearance="outline">
        <mat-label>Estado</mat-label>
        <mat-select placeholder="Estado" [formControl]="estadoControl" panelClass="mat-select-dropdown">
          <mat-option [value]="" (click)="estadoControl.setValue('')">--</mat-option>
          <mat-option *ngFor="let estado of estadoList" [value]="estado">
            {{estado}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- ***** Fecha Generación Desde ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 48.5%" fxFlex.lt-sm="1 1 100%" appearance="outline">
        <mat-label>Fec Generación Desde</mat-label>
        <input matInput [matDatepicker]="fecGenDesde" [formControl]="fecGenDesdeControl"
               (dateChange)="setFecGenDesde(fecGenDesdeControl.value)">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="fecGenDesde"></mat-datepicker-toggle>
        <mat-datepicker #fecGenDesde></mat-datepicker>
      </mat-form-field>

      <!-- ***** Fecha Generación Hasta ***** -->
      <mat-form-field fxFlex="1 1 19%" fxFlex.lt-lg="1 1 48.5%" fxFlex.lt-sm="1 1 100%" appearance="outline">
        <mat-label>Fec Generación Hasta</mat-label>
        <input matInput [matDatepicker]="fecGenHasta" [formControl]="fecGenHastaControl"
               (dateChange)="setFecGenHasta(fecGenHastaControl.value)">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="fecGenHasta"></mat-datepicker-toggle>
        <mat-datepicker #fecGenHasta></mat-datepicker>
      </mat-form-field>
    </div>
  </form>

  <!-- ***** IMPRESORAS / EMAIL ALL BUTTON ***** -->
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap=".75rem">
    <mat-form-field appearance="standard" *ngIf="showTabledata">
      <mat-label>Select Impresoras</mat-label>
      <input matInput [(ngModel)]="impresoraRemito.impresoraField" [matAutocomplete]="autoImpresoras"
             (ngModelChange)="changeImpresora(impresoraRemito)" [disabled]="disableEmailAllButton">
      <mat-autocomplete #autoImpresoras="matAutocomplete">
        <mat-option *ngFor="let impresoras of filteredImpresoras(impresoraRemito)"
                    [value]="impresoras">
          {{impresoras}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button *ngIf="showTabledata" type="submit" fxFlexAlign="center" mat-icon-button class="view-remito-buttons"
            (click)="emailAllRemitos()" [disabled]="disableEmailAllButton">
      <mat-icon>email</mat-icon>
    </button>
  </div>

  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>

  <!-- ***** TABLE ***** -->
  <div class="table-height table-flex">
    <table mat-table [dataSource]="dataSource" matSort  *ngIf="showTabledata" matSortActive="nroRemito" matSortDirection="desc" matSortDisableClear (matSortChange)="onSortChange()" #dataTable>

      <!-- Row Checkbox -->
      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let element" class="center">
          <mat-checkbox (change)="onChange(element)" [(ngModel)]="element.isChecked"
                        [hidden]="estaCancelado(element)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- remito Type Column -->
      <ng-container matColumnDef="remitoTypeField">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo
          <fab-string-filter #tableFilter columnDef="remitoTypeField" [operators]="operators"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="center">
          {{element.remitoTypeField}}
        </td>
      </ng-container>
      <ng-container matColumnDef="clase">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Clase
          <fab-string-filter #tableFilter columnDef="clase" [operators]="operators"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="center">
          {{element.clase}}
        </td>
      </ng-container>
      <!-- Pto Emision Column -->
      <ng-container matColumnDef="ptoEmision">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Pto Emision
          <fab-string-filter #tableFilter columnDef="ptoEmision" [operators]="operators"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="center">
          {{element.ptoEmision}}
        </td>
      </ng-container>
      <!-- Nro Remito Column -->
      <ng-container matColumnDef="nroRemito">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nro Remito
          <fab-string-filter #tableFilter columnDef="nroRemito" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="center">
          <span>
            <a [routerLink]="['/create-vehicle-remito/'+ element.ptoEmision + '/' + element.nroRemito.toString()]">
              {{element.nroRemito.toString().padStart(8, '0')}}
            </a>
          </span>
        </td>
      </ng-container>

      <!-- Origen Column -->
      <ng-container matColumnDef="descOrigen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Origen
          <fab-string-filter #tableFilter columnDef="descOrigen" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="center-padding">
          {{element.descOrigen}}
        </td>
      </ng-container>

      <!-- Destinatario Column -->
      <ng-container matColumnDef="nombreDestino">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Destinatario
          <fab-string-filter #tableFilter columnDef="nombreDestino" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="center-padding">
          {{element.nombreDestino}}
        </td>
      </ng-container>

      <!-- Transporte Column -->
      <ng-container matColumnDef="nombreTransp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Transporte
          <fab-string-filter #tableFilter columnDef="nombreTransp" [operators]="operators"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="center-padding">
          {{element.nombreTransp}}
        </td>
      </ng-container>

      <!-- Fec Gen Column -->
      <ng-container matColumnDef="fecGen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Fec Gen
          <fab-date-filter #tableFilter columnDef="fecGen" [operators]="dateOperators" (filterChange)="filterChange($event);"></fab-date-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.fecGen | customDate}} </td>
      </ng-container>

      <!-- Fecha De Envio Column -->
      <ng-container matColumnDef="fechaDeEnvio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Despacho
          <fab-date-filter #tableFilter columnDef="fechaDeEnvio" [operators]="dateOperators" (filterChange)="filterChange($event);"></fab-date-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.fechaDeEnvio | date : "dd/MM/yyyy" : "UTC"}} </td>
      </ng-container>

     <!-- Status Column -->
      <ng-container matColumnDef="estadoRemito">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado
          <fab-string-filter #tableFilter columnDef="estadoRemito" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element"  class="center"> {{element.estadoRemito}} </td>
      </ng-container>

      <!-- Impresoras Column -->
      <ng-container matColumnDef="impresorasList">
        <th mat-header-cell *matHeaderCellDef>Impresoras</th>
        <td mat-cell *matCellDef="let element" class="center">
          <mat-form-field appearance="standard">
            <mat-label>Select Impresoras</mat-label>
            <input matInput [(ngModel)]="element.impresoraField" [matAutocomplete]="autoImpresoras"
                   (ngModelChange)="changeImpresora(element)" [disabled]="disableEmailButton || estaCancelado(element)">
            <mat-autocomplete #autoImpresoras="matAutocomplete">
              <mat-option *ngFor="let impresoras of filteredImpresoras(element)"
                          [value]="impresoras">
                {{impresoras}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Email/Cancel Buttons Column -->
      <ng-container matColumnDef="remitoButtons">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let element"  class="left" nowrap="true">
          <button mat-icon-button class="view-remito-buttons" *ngIf="estaCancelado(element)"
                  (click)="verCancelarObservacion(element)">
            <mat-icon>comment</mat-icon>
          </button>
          <button mat-icon-button class="view-remito-buttons"
                  *ngIf="!estaCancelado(element)" (click)="cancelarRemito(element)">
            <mat-icon >cancel</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [hidden]="!showTabledata"
                 [pageSize]="pageSizes[0]"
                 [pageSizeOptions]="pageSizes"
                 [length]="totalElements"
                 (page)="updatePageState()">
  </mat-paginator>
</div>
